import { call, put, select, takeLatest } from 'redux-saga/effects'
import { IOptionsResponse } from '../../../common/common.types'
import { throwPcrException } from '../../../features/pcr/store/pcr.actions'
import { ClientDataConstants } from '../../../features/clientData/store/clientData.constants'
import { getServiceIdSelector } from '../../../features/user/selectors'
import { sort } from '../../../utilities/options.util'
import { ProcedureService } from '../services/procedure.service'
import { setComplicationsOptions } from '../store/procedure.actions'

export function* getComplicationsOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const procedureService = new ProcedureService(serviceId)
  try {
    const complicationsResponse: IOptionsResponse = yield call([
      procedureService,
      procedureService.getComplicationsOptions,
    ])
    const { entity } = complicationsResponse
    sort(entity)
    yield put(setComplicationsOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getComplicationsOptions() error: ${e}`))
  }
}

export function* getComplicationsOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getComplicationsOptions)
}
